import React from "react"
import {Box, Typography} from "@mui/material"
import {alpha} from "@mui/material/styles"
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome"

import {colors} from "@indebted/theme/colors"

// A slot container: every decision about what goes in it is the page's, so the
// panel stays channel-agnostic and later work fills a slot rather than editing
// this file.
function IdentifyPanel({
	alerts,
	hints,
	candidates,
	search,
	outcome,
	actions,
}: {
	alerts?: React.ReactNode
	hints?: React.ReactNode
	candidates?: React.ReactNode
	search?: React.ReactNode
	outcome?: React.ReactNode
	actions?: React.ReactNode
}) {
	return (
		<Box
			p={2.5}
			display="flex"
			flexDirection="column"
			gap={3}
			borderRadius={2}
			sx={(theme) => ({
				border: "1px solid",
				borderColor: colors.gray["200"],
				bgcolor: alpha(theme.palette.primary.main, 0.03),
			})}
		>
			<Box display="flex" alignItems="center" gap={2}>
				<AutoAwesomeIcon fontSize="small" color="primary" />
				<Typography variant="subtitle1" fontWeight={600} component="h2">
					Identify the customer
				</Typography>
			</Box>
			{alerts}
			{hints}
			{candidates}
			{search}
			{outcome}
			{actions}
		</Box>
	)
}

export {IdentifyPanel}
